// Time helpers for the Branch Calendar.
//
// The calendar renders times in Asia/Makassar (Bali, UTC+8) so we keep all
// conversions in one place. `baliMinutes` and friends convert an ISO string
// into local minutes-of-day; `baliIsoFromLocal` does the inverse when we need
// to build an ISO string from a local date + minute offset (e.g. after a drag
// & drop drops onto slot 13:30).

export function pad(n) { return String(n).padStart(2, "0"); }

export function baliParts(iso) {
  const [h, m] = new Date(iso).toLocaleTimeString("en-GB", {
    hour: "2-digit", minute: "2-digit", timeZone: "Asia/Makassar", hour12: false,
  }).split(":");
  return { h: parseInt(h, 10), m: parseInt(m, 10) };
}

export function baliMinutes(iso) {
  const { h, m } = baliParts(iso);
  return h * 60 + m;
}

export function baliLocalTime(iso) {
  const { h, m } = baliParts(iso);
  return `${pad(h)}:${pad(m)}`;
}

// Given a Bali-local date + HH:mm (as minutes), produce a UTC ISO string.
// Bali is UTC+8, so we shift by -8 hours when constructing the UTC time.
export function baliIsoFromLocal(date, minutes) {
  const y = date.getFullYear(), mo = date.getMonth(), d = date.getDate();
  const hh = Math.floor(minutes / 60);
  const mm = minutes % 60;
  return new Date(Date.UTC(y, mo, d, hh - 8, mm, 0)).toISOString();
}

// Parse an "HH:MM" string into minutes-of-day, falling back to `fb` when the
// string is empty/undefined. Used everywhere schedule strings are read.
export function parseHM(s, fb) {
  if (!s) return fb;
  const [h, m] = s.split(":").map((x) => parseInt(x, 10));
  return h * 60 + m;
}
